<template>
  <el-form-item
    :key="form.key"
    :label="form.cname+':'"
    :prop="prop"
    :rules="rule">
    <el-input-number
      v-if="status === 'edit'"
      v-model="form.fieldValue"
      style="width:100%"
      :controls="false"
      :precision="4"
      :min="0"></el-input-number>
    <span v-else>{{ form.fieldValue || '&nbsp;' }}</span>
  </el-form-item>
</template>

<script>
export default {
  name: 'FormNumber',
  props: {
    item: {
      type: Object,
      required: true,
      default() {
        return {}
      }
    },
    prop: {
      type: String,
      required: true
    },
    status: {
      type: String,
      default: 'edit'
    }
  },
  computed: {
    form: {
      get() {
        return this.item
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    rule() {
      return [
        {
          required: this.form.mandatory,
          message: this.form.cname + '不能为空',
          trigger: 'blur'
        }
      ]
    }
  }
}
</script>
